import customEvents from './customEvents.js';
window.theme.customEvents = customEvents;

const template = window.theme ? window.theme.template : null; 
const pageType = window.theme ? window.theme.pageType : null;

const isCheckout = Shopify ? Shopify.Checkout : null;
import './scripts/generalScripts'
import './scripts/categoriesChange'
console.log({
    template, 
    pageType,
    isCheckout
});

import './scripts/featuredCollection';
import './scripts/categoriesChange';
import './scripts/pdpTabs';
import './scripts/upsellCart';

if (template === 'page.box-builder') {
    const selectors = {
        json: '#box-builder-json',
        app: '#box-builder',
    }

    let mainFunctionClosure;
    let isCssLoaded = false;

    let timeToRun = 0;

    import("./styles/modules/box-builder/boxBuilderMain.scss").then(function () {
        isCssLoaded = true;
    }).catch(function (error) {
        console.warn(error);
    });

    import('./modules/box-builder/boxBuilderMain.js').then(function (exports) {
        mainFunctionClosure = exports.main;
    }).catch(function (error) {
        console.warn(error);
    });

    const waitingForCssAndJs = setInterval(() => {
        if (isCssLoaded && mainFunctionClosure) {
            mainFunctionClosure(selectors);
            console.log("timeToRun: ", timeToRun);
            clearInterval(waitingForCssAndJs);
        } else {
            timeToRun += 1;
        }
    }, 1);
}
